import { fetchPricingFromServerNew } from "../store/slice/model/ProductPricing";
import { isArray } from "underscore";
import Product from "@system/config/product";
import axios_c_for_price_and_inventory from "src/service/axios_c_for_price_and_inventory";
import { __remove, __set } from "src/store/axios_indicator";
import liveAuth from "src/helper/liveAuth";
import AuthConfig from "@system/config/auth";
import System from "src/helper/system";
import StoreInner from "src/storeWire";
import { SET_CART_PRODUCT_PRICING_DATA_BY_ERP_PART_NUMBER } from "src/store/slice/model/Cart";
import ProductRepository from "src/repository/ProductRepository";
import storeInUse from "../storeWire";
import Helper from "src/support/Helper";

class ProductPricingAPICall {

    async get_data_from_master_store_by_params(params) {
        let data = {};
        let master_data = {};
        let ERPPartNumber_map_with_ItemNumber = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductPricing.master_data;
            ERPPartNumber_map_with_ItemNumber = storeIn.entities.model_ProductListing.ERPPartNumber_map_with_ItemNumber;
        }

        /**
         * if erppartnumber null set manufacturer part number at assets data from master data
         * Author: Devanshi Patel
         */
        params.map((v) => {
            if (master_data[v.ERPPartNumber] !== undefined) {
                data[v.ERPPartNumber] = master_data[v.ERPPartNumber];
                if (ERPPartNumber_map_with_ItemNumber && ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber] !== undefined) {
                    data[ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber]] = master_data[v.ERPPartNumber]
                }
            }
            if (master_data[v.manufacturerPartNumber]) {
                data[v.manufacturerPartNumber] = master_data[v.manufacturerPartNumber];
            }
        });
        return data;
    }

    async params_maker_from_master_data(params) {
        let server_left_params = [];
        let master_data = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductPricing.master_data;
        }
        params.map((v) => {
            if (master_data[v.ERPPartNumber] === undefined) {
                server_left_params.push(v);
            }
        });
        return {
            server_left_params
        };
    }


    getLowestMarketPrice(priceList) {
        if (priceList && isArray(priceList) && priceList[priceList.length - 1] !== undefined && priceList[priceList.length - 1].marketPrice !== undefined) {
            return parseFloat(priceList[priceList.length - 1].marketPrice);
        }
        return 0;
    }


    async axiosFetchPricingFromServer(server_left_params, updatePricingInCartPricingFlag = true) {
        if (!liveAuth.check()) {
            return {};
        }
        __set('PRODUCT_PRICING_API_CALL');
        const data = {
            "requestIn": server_left_params,
            "requestOut": [],
            "isHeaderData": {
                "accountNumber": await AuthConfig.getAccountNumber(),
                "salesOrg": await System.auth('salesOrg'),
            },
        };
        const config = {
            method: 'post',
            url: Product.PRODUCT_PRICING,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = [];
        let manufacturerPartNumber_key_ItemNumber = {};
        if (config.data !== undefined && config.data.requestIn !== undefined) {
            let requestIn = [];
            await Promise.all(config.data.requestIn.map(async (v, i) => {
                let ERPPartNumber = null;
                if (v.PartNumber !== undefined && v.PartNumber) {
                    ERPPartNumber = v.PartNumber;
                }
                if (ERPPartNumber !== null && v.ERPPartNumber !== undefined && v.ERPPartNumber) {
                    ERPPartNumber = v.ERPPartNumber;
                } else {
                    ERPPartNumber = v.ItemNumber
                }
                let webCode = await new ProductRepository().getWebCodeFlagByERPPartNumberFromMasterStorage(ERPPartNumber);
                if (webCode !== '4') {
                    let ERPPartNumberModifiedObject = await new ProductRepository().getERPPartNumberModifiedByERPPartNumberFromMasterStorage(ERPPartNumber, true);
                    if (ERPPartNumberModifiedObject && ERPPartNumberModifiedObject.ERPPartNumberModified === true) {
                        v.manufacturerPartNumber = ERPPartNumberModifiedObject.ManufacturerPartNumber;
                        v.ItemNumber = ERPPartNumberModifiedObject.ItemNumber;
                        v.ERPPartNumber = ERPPartNumber;
                        v.partNumber = '';
                        v.PartNumber = ''; // blank same as partNumber
                        requestIn.push(v);
                        if (manufacturerPartNumber_key_ItemNumber[ERPPartNumberModifiedObject.ManufacturerPartNumber] !== undefined) {
                            manufacturerPartNumber_key_ItemNumber[ERPPartNumberModifiedObject.ManufacturerPartNumber].push(ERPPartNumberModifiedObject.ItemNumber);
                        } else {
                            manufacturerPartNumber_key_ItemNumber[ERPPartNumberModifiedObject.ManufacturerPartNumber] = [ERPPartNumberModifiedObject.ItemNumber];
                        }
                    } else {

                        if (!(ERPPartNumber === undefined || ERPPartNumber === null || ERPPartNumber === '' || ERPPartNumber === ' ')) {
                            v.manufacturerPartNumber = v.ManufacturerPartNumber;
                            v.ERPPartNumber = ERPPartNumber;
                            v.partNumber = this.checkItemNumberIsERPPartNumber(v, ERPPartNumber) === null ? '' : this.checkItemNumberIsERPPartNumber(v, ERPPartNumber);
                            v.PartNumber = this.checkItemNumberIsERPPartNumber(v, ERPPartNumber) === null ? '' : this.checkItemNumberIsERPPartNumber(v, ERPPartNumber);
                            requestIn.push(v);
                        }
                    }
                }
                // Remove unused properties
                if (v['assets'] !== undefined) {
                    delete v['assets'];
                }
                if (v['ObsoleteFlag'] !== undefined) {
                    delete v['ObsoleteFlag'];
                }
            }));

            config.data.requestIn = requestIn;
            if (config.data.requestIn.length > 0) {
                await axios_c_for_price_and_inventory(config)
                    .then(function (response) {
                        res = response.data.data.requestOut;
                    }).catch(function () {
                        //System.toast('Pricing Failed', 'error')
                        __remove('PRODUCT_PRICING_API_CALL');
                    });
            } else {
                __remove('PRODUCT_PRICING_API_CALL');
            }
        } else {
            __remove('PRODUCT_PRICING_API_CALL');
        }
        let res_f = {};
        let ERPPartNumber_map_with_ItemNumber = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            ERPPartNumber_map_with_ItemNumber = storeIn.entities.model_ProductListing.ERPPartNumber_map_with_ItemNumber;
        }
        if (res.length) {
            await Promise.all(res.map((v) => {
                let failed_price_detected = false;
                if (v.error === '015') {
                    failed_price_detected = true;
                }
                if (v.error === '007') {
                    failed_price_detected = true;
                }
                if (v.error === '013') {
                    failed_price_detected = true;
                }
                if (v.error === 'Internal error') {
                    failed_price_detected = true;
                }
                if (v.message === 'Please contact Avnet') {
                    failed_price_detected = true;
                }
                if (v.message.includes('Can\'t find')) {
                    failed_price_detected = true;
                }
                if (isNaN(parseFloat(v.marketPrice)) !== false) {
                    failed_price_detected = true;
                }
                if (failed_price_detected === false) {
                    if (v.partNumber) {
                        v.ERPPartNumber = v.partNumber;
                        if (ERPPartNumber_map_with_ItemNumber && ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber] !== undefined) {
                            v.ItemNumber = ERPPartNumber_map_with_ItemNumber[v.ERPPartNumber];
                        }
                        if (res_f[v.partNumber] !== undefined) {
                            res_f[v.partNumber].push(v);
                        } else {
                            res_f[v.partNumber] = [v];
                        }
                    }

                    /**
                     * if erppartnumber null and manufacturer part number is set for pricing return data with manufacturer part number
                     * Author: Devanshi Patel
                     */
                    if (v.manufacturerPartNumber) {
                        if (res_f[v.manufacturerPartNumber] !== undefined) {
                            res_f[v.manufacturerPartNumber].push(v);
                        } else {
                            res_f[v.manufacturerPartNumber] = [v];
                        }

                        if (manufacturerPartNumber_key_ItemNumber[v.manufacturerPartNumber] !== undefined && isArray(manufacturerPartNumber_key_ItemNumber[v.manufacturerPartNumber])) {

                            manufacturerPartNumber_key_ItemNumber[v.manufacturerPartNumber].map((v_h_mpn_ItemNumber) => {
                                v.ERPPartNumber = v_h_mpn_ItemNumber;
                                v.ItemNumber = v_h_mpn_ItemNumber;
                                v.partNumber = v.ERPPartNumber;
                                if (res_f[v_h_mpn_ItemNumber] !== undefined) {
                                    res_f[v_h_mpn_ItemNumber].push(v);
                                } else {
                                    res_f[v_h_mpn_ItemNumber] = [v];
                                }
                            })
                        }
                    }

                }
            }));
        }
        let res_sorted = {};
        if (Object.entries(res_f).length > 0) {
            await Promise.all(Object.entries(res_f).map((v) => {
                let v_sorted = v[1].sort((a, b) => a.demandQuantityOut - b.demandQuantityOut);
                res_sorted[v[0]] = v_sorted;
                if (ERPPartNumber_map_with_ItemNumber && ERPPartNumber_map_with_ItemNumber[v[0]] !== undefined) {
                    res_sorted[ERPPartNumber_map_with_ItemNumber[v[0]]] = v_sorted;
                }
            }));
        }

        __remove('PRODUCT_PRICING_API_CALL');
        if (updatePricingInCartPricingFlag === true) {
            await Promise.all(Object.entries(res_sorted).map((v) => {
                this.updatePricingInCartPricing(v[0], v[1]);
            }));
        }
        return res_sorted;
    }

    async getPricingNew(server_left_params, updatePricingInCartPricingFlag, isStoreInRedux = true) {
        if ((!liveAuth.check()) || 
        (System.getOrderBlockCreditRiskFlagBySpeedboat().isOrderBlock)) {
            return {};
        }
        __set('PRODUCT_PRICING_API_CALL');
        server_left_params.map((params_single) => {
            if (params_single.customerPartNumber) {
                params_single.customerPartNumber = Helper.toUpperCase(params_single.customerPartNumber)
            }
        });

        const data = {
            "requestIn": server_left_params
        };
        const config = {
            method: 'post',
            url: Product.PRODUCT_PRICING_NEW,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: data
        };
        let res = [];
        /**
         * If no any request in param then stop API call
         * Author: Devanshi Patel
         */
        if (data && data.requestIn && data.requestIn.length > 0) {
            await axios_c_for_price_and_inventory(config)
                .then(function (response) {
                    res = response.data.data.requestOut;
                }).catch(function () {
                    //System.toast('Pricing Failed', 'error')
                    __remove('PRODUCT_PRICING_API_CALL');
                });
        }

        let res_f = {};
        if (res.length) {
            await Promise.all(res.map((v) => {
                let failed_price_detected = false;
                if (v.error === '015') {
                    failed_price_detected = true;
                }
                if (v.error === '007') {
                    failed_price_detected = true;
                }
                if (v.error === '013') {
                    failed_price_detected = true;
                }
                if (v.error === 'Internal error') {
                    failed_price_detected = true;
                }
                if (v.message === 'Please contact Avnet') {
                    failed_price_detected = true;
                }
                if (v.message.includes('Can\'t find')) {
                    failed_price_detected = true;
                }

                // if (failed_price_detected === false) {
                if (v.erpMfrPartNumber || v.partNumber) {
                    res_f[v.erpMfrPartNumber + '-' + v.partNumber] = v;
                    if (v.customerPartNumber) {
                        /**
                         * this is used when multiple entries available for same product
                         * Author: Devanshi Patel
                         */
                        res_f[v.erpMfrPartNumber + '-' + v.partNumber + '-' + v.customerPartNumber] = v;
                    }
                }
                // }
            }));
        }

        __remove('PRODUCT_PRICING_API_CALL');
        if (updatePricingInCartPricingFlag === true) {
            await Promise.all(Object.entries(res_sorted).map((v) => {
                this.updatePricingInCartPricing(v[0], v[1]);
            }));
        }
        if (isStoreInRedux) {
            await storeInUse.dispatch(fetchPricingFromServerNew(res_f));
        }
        return res_f;
    }


    updatePricingInCartPricing(ERPPartNumber, single_pricing_array) {
        let StoreHere;
        try {
            StoreHere = StoreInner.getState();
        } catch (e) {
        }
        if (StoreHere && StoreHere.entities !== undefined && StoreHere.entities.Cart !== undefined && StoreHere.entities.Cart.CART_PRODUCT_PRICING_DATA !== undefined &&
            StoreHere.entities.Cart.CART_PRODUCT_PRICING_DATA[ERPPartNumber] !== undefined) {
            StoreInner.dispatch(SET_CART_PRODUCT_PRICING_DATA_BY_ERP_PART_NUMBER({
                CART_PRODUCT_PRICING_DATA: {
                    ERPPartNumber,
                    single_pricing_array
                }
            }));
        }
    }

    checkItemNumberIsERPPartNumber(productHere, partNumber) {
        if (productHere.ItemNumber && productHere.ItemNumber.trim() !== '' && productHere.ItemNumber === partNumber) {
            return '';
        }
        return partNumber;
    }
}

export default ProductPricingAPICall;